import SockJS from "sockjs-client/dist/sockjs.min";
import { Client } from "@stomp/stompjs";

let stompClient = null;

export function connectClaudeSocket(taskId, onMessageReceived, onErrorReceived) {
  const token = document.querySelector('meta[name="_csrf"]');
  const header = document.querySelector('meta[name="_csrf_header"]');

  try {
    const socket = new SockJS("/ws", null, {
      transports: ["websocket"],
    });

    stompClient = new Client({
      webSocketFactory: () => socket,
      reconnectDelay: 5000,
      debug: (str) => console.log("[Claude WebSocket]", str),
      connectHeaders:
        header && token
          ? {
              [header.content]: token.content,
            }
          : {},
      onConnect: () => {
        console.log("[Claude WebSocket] Verbunden.");

        const destination = `/topic/ai-generation/${taskId}`;
        console.log(`[Claude WebSocket] Subscribing to: ${destination}`);

        stompClient.subscribe(destination, (message) => {
          try {
            const result = JSON.parse(message.body);
            console.log("[Claude WebSocket] Nachricht empfangen:", result);

            if (result.status === "ERROR") {
              if (onErrorReceived) onErrorReceived(result);
            } else {
              if (onMessageReceived) onMessageReceived(result);
            }

            // Bei finalen Stati die Verbindung schließen
            if (result.status === "SUCCESS" || result.status === "ERROR") {
              disconnectClaudeSocket();
            }
          } catch (e) {
            console.error("[Claude WebSocket] Fehler beim Verarbeiten der Nachricht:", e);
          }
        });
      },
      onStompError: (frame) => {
        console.error("[Claude WebSocket] Fehler:", frame.headers["message"]);
        if (onErrorReceived) onErrorReceived({ error: frame.headers["message"] });
      },
      onWebSocketError: (event) => {
        console.error("[Claude WebSocket] WebSocket-Fehler:", event);
        if (onErrorReceived) onErrorReceived({ error: "WebSocket Verbindungsfehler." });
      },
    });

    stompClient.activate();
  } catch (error) {
    console.error("[Claude WebSocket] Fehler beim Verbinden:", error);
    if (onErrorReceived) onErrorReceived({ error: "Fehler beim Initialisieren der Verbindung." });
  }
}

export function disconnectClaudeSocket() {
  if (stompClient) {
    stompClient.deactivate();
    stompClient = null;
    console.log("[Claude WebSocket] Verbindung getrennt.");
  }
}
